import {
  goTo,
} from '../../actions/routing';
import config from '../../config';
import { muleSoftFetch } from '../../utils/fetch';
import { parseQueryString } from '../../utils/queryString';

const INITIAL = 'INITIAL';
const EM_SIGNUP_SUCCESS = 'EM_SIGNUP_SUCCESS';
const EM_SIGNUP_FAIL = 'EM_SIGNUP_FAIL';
const EM_SIGNUP_SERVER_REQ_PENDING = 'EM_SIGNUP_SERVER_REQ_PENDING';
const EM_SIGNUP_SERVER_REQ_COMPLETE = 'EM_SIGNUP_SERVER_REQ_COMPLETE';
// constants for submitResendActivationLink
const EM_REG_EXPACC_REACTIVATE_SUBMIT = 'EM_REG_EXPACC_REACTIVATE_SUBMIT';
const EM_REG_EXPACC_REACTIVATE_SUCCESS = 'EM_REG_EXPACC_REACTIVATE_SUCCESS';
const EM_REG_EXPACC_REACTIVATE_FAIL = 'EM_REG_EXPACC_REACTIVATE_FAIL';
// constants for reactivation if username already used and reactivate
const EM_REG_ACC_REACTIVATE_SUBMIT = 'EM_REG_ACC_REACTIVATE_SUBMIT';
const EM_REG_ACC_REACTIVATE_SUCCESS = 'EM_REG_ACC_REACTIVATE_SUCCESS';
const EM_REG_ACC_REACTIVATE_FAIL = 'EM_REG_ACC_REACTIVATE_FAIL';
const initialState = {
  contactType: 'email',
  password: '',
  email: '',
  countryCode: '',
  mobile: '',
  acceptDataPolicy: false,
  receiveNews: false,
  locale: 'en',
  isSubmitting: false,
  isLoading: false,
  isSignUpSuccess: false,
  errorCode: '',
  isExpAccReActvatSucc: false,
  isExpAccReActvatFail: false,
  maskedEmailByExpReactvtSucc: '',
  isAccReActvatSucc: false,
  isAccReActvatFail: false,
  contactByReactvtSucc: '',
};


export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case INITIAL:
      return {
        ...state,
        input: action.input,
        isSubmitSuccessed: false,
        isLoading: false,
      };

    case EM_SIGNUP_SERVER_REQ_PENDING:
      return {
        ...state,
        isLoading: true,
        isSubmitting: true,
      };
    case EM_SIGNUP_SERVER_REQ_COMPLETE:
      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
      };
    case EM_SIGNUP_SUCCESS:
      return {
        ...state,
        isSignUpSuccess: true,
        email: action.email,
        mobile: action.mobile,
        countryCode: action.countryCode,
        contactType: action.contactType,
      };
    case EM_SIGNUP_FAIL:
      return {
        ...state,
        isSignUpSuccess: false,
        errorCode: action.errorCode || '',
        email: action.email,
        mobile: action.mobile,
        countryCode: action.countryCode,
        contactType: action.contactType,
      };
    case EM_REG_EXPACC_REACTIVATE_SUBMIT:
      return {
        ...state,
        isSubmitting: true,
      };
    case EM_REG_EXPACC_REACTIVATE_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
        isExpAccReActvatSucc: action.isExpAccReActvatSucc,
        isExpAccReActvatFail: action.isExpAccReActvatFail,
        maskedEmailByExpReactvtSucc: action.maskedEmailByExpReactvtSucc,

      };
    case EM_REG_EXPACC_REACTIVATE_FAIL:
      return {
        ...state,
        isSubmitting: false,
        isExpAccReActvatSucc: action.isExpAccReActvatSucc,
        isExpAccReActvatFail: action.isExpAccReActvatFail,
        maskedEmailByExpReactvtSucc: action.maskedEmailByExpReactvtSucc,
        errorCode: action.errorCode,
      };
    case EM_REG_ACC_REACTIVATE_SUBMIT:
      return {
        ...state,
        isSubmitting: true,
      };
    case EM_REG_ACC_REACTIVATE_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
        isAccReActvatSucc: action.isAccReActvatSucc,
        isAccReActvatFail: action.isAccReActvatFail,
        contactByReactvtSucc: action.contactByReactvtSucc,

      };
    case EM_REG_ACC_REACTIVATE_FAIL:
      return {
        ...state,
        isSubmitting: false,
        isAccReActvatSucc: action.isAccReActvatSucc,
        isAccReActvatFail: action.isAccReActvatFail,
        contactByReactvtSucc: action.contactByReactvtSucc,
        errorCode: action.errorCode,
      };
    default:
      return state;
  }
}


export function submitEmmaSignUp(submitValues, fromPage = '') {
  return async (dispatch, getState) => {
    const currLang = getState().language.lang;
    const body = {
      'registrationRequest': {
        'contactType': submitValues.contactType,
        ...submitValues.contactType === 'mobile' ? {
          'countryCode': submitValues.countryCode,
          'mobile': submitValues.mobile,
        } : {
          'email': submitValues.email.toLowerCase(),
        },
        'password': submitValues.password,
        'acceptDataPolicy': submitValues.acceptDataPolicy.toString(),
        'receiveNews': submitValues.receiveNews.toString(),
        'acceptPIC': submitValues.acceptPIC.toString(),
        // HKEMMA-102672 - default to 'Y' because of API validation must 'Y'
        // 'acceptPIPL': Boolean(submitValues.acceptPIPL).toString(),
        'acceptPIPL': 'true',
        'locale': currLang || 'en',
        'captchaToken': submitValues.captchaToken,
        'receiveClaimSettle': 'false',
      },
    };

    dispatch({
      type: EM_SIGNUP_SERVER_REQ_PENDING,
    });
    const queryParams = {
      featureName: 'cwp',
    };
    const option = {
      headers: {
        apikey: config.muleApiKey
      }
    };
    await muleSoftFetch(
      parseQueryString(`${config.webview.muleApiBaseUrl}/customers/registration`, queryParams),
      'post',
      body,
      option
    )
      .then(() => {
        dispatch({
          type: EM_SIGNUP_SERVER_REQ_COMPLETE,
        });
        dispatch({
          type: EM_SIGNUP_SUCCESS,
          email: submitValues.email,
          countryCode: submitValues.countryCode,
          mobile: submitValues.mobile,
          contactType: submitValues.contactType,
        });
        dispatch(goTo(`/${currLang}/${config.webview.identityFEPath}/emma/signup/cwp/linksend-success`));
      }).catch((error) => {
      // eslint-disable-next-line no-console
        console.log('error', error);
        dispatch({
          type: EM_SIGNUP_SERVER_REQ_COMPLETE,
        });
        if (error.response) {
          dispatch({
            type: EM_SIGNUP_FAIL,
            errorCode: error.response.data.response.reasonCode,
            email: submitValues.email,
            countryCode: submitValues.countryCode,
            mobile: submitValues.mobile,
            contactType: submitValues.contactType,
          });
          if (error.response.data.response.reasonCode === 'CUSEXP20' || error.response.data.response.reasonCode === 'REGEXP4') {
            dispatch(goTo(`/${currLang}/${config.webview.identityFEPath}/emma/signup/cwp/username-used?fromPage=${encodeURIComponent(fromPage)}`));
          } else {
            dispatch(goTo(`${currLang}/${config.webview.identityFEPath}/emma/signup/cwp/fail?fromPage=${encodeURIComponent(fromPage)}`));
          }
        } else {
          dispatch({
            type: EM_SIGNUP_FAIL,
            errorCode: 'NWK',
            userEmail: '',
          });
          dispatch(goTo(`${currLang}/${config.webview.identityFEPath}/emma/signup/cwp/fail?fromPage=${encodeURIComponent(fromPage)}`));
        }
      });
  };
}

export const submitResendActivationLink = (submitValues) => {
  return async (dispatch, getState) => {
    const formData = {
      token: submitValues.token,
      locale: submitValues.locale || 'en',
      captchaToken: submitValues.captchaToken || '',
    };

    dispatch({
      type: EM_REG_EXPACC_REACTIVATE_SUBMIT,
    });
    dispatch({
      type: EM_SIGNUP_SERVER_REQ_PENDING,
    });
    const queryParams = {
      featureName: 'reactivateuserCWP',
    };
    const option = {
      headers: {
        apikey: config.muleApiKey
      }
    };
    await muleSoftFetch(
      parseQueryString(`${config.webview.muleApiBaseUrl}/customers/registration`, queryParams),
      'post',
      { registrationRequest: formData },
      option
    ).then((response) => {
        dispatch({
          type: EM_REG_EXPACC_REACTIVATE_SUCCESS,
          isExpAccReActvatSucc: true,
          isExpAccReActvatFail: false,
          maskedEmailByExpReactvtSucc: response.data.loginId,
        });
      // dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/emma/forget/password/reset-success`));
      }).catch((error) => {
        dispatch({
          type: EM_SIGNUP_SERVER_REQ_PENDING,
        });
        if (error.response) {
          dispatch({
            type: EM_REG_EXPACC_REACTIVATE_FAIL,
            isExpAccReActvatSucc: false,
            isExpAccReActvatFail: true,
            maskedEmailByExpReactvtSucc: '',
            errorCode: error.response.data.code,
          });
        } else {
          dispatch({
            type: EM_REG_EXPACC_REACTIVATE_FAIL,
            isExpAccReActvatSucc: false,
            isExpAccReActvatFail: true,
            maskedEmailByExpReactvtSucc: '',
            errorCode: '',
          });
          dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/emma/signup/cwp/activation/fail`));
        }
      });
  };
};


export const submitReactivateAccount = ({ captchaToken }) => {
  return async (dispatch, getState) => {
    const currLang = getState().language.lang;
    const { email, countryCode, mobile, contactType } = getState().emmaSignUp;

    const formData = {
      locale: currLang || 'en',
      contactType,
      ...contactType === 'email' ? {
        email: email.toLowerCase(),
      } : {
        countryCode,
        mobile,
      },
      captchaToken: captchaToken || '',
    };

    const loginId = contactType === 'email' ? email : `${countryCode}${mobile}`;

    dispatch({
      type: EM_REG_ACC_REACTIVATE_SUBMIT,
    });
    dispatch({
      type: EM_SIGNUP_SERVER_REQ_PENDING,
    });

    const queryParams = {
      featureName: 'reactivateuserCWP',
    };
    const option = {
      headers: {
        apikey: config.muleApiKey
      }
    };
    await muleSoftFetch(
      parseQueryString(`${config.webview.muleApiBaseUrl}/customers/registration`, queryParams),
      'post',
      { registrationRequest: formData },
      option
    ).then(() => {
        dispatch({
          type: EM_REG_ACC_REACTIVATE_SUCCESS,
          isAccReActvatSucc: true,
          isAccReActvatFail: false,
          contactByReactvtSucc: loginId,
        });
        dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/emma/signup/cwp/reactivation-result`));
      }).catch((error) => {
        dispatch({
          type: EM_SIGNUP_SERVER_REQ_PENDING,
        });
        if (error.response) {
          dispatch({
            type: EM_REG_ACC_REACTIVATE_FAIL,
            isAccReActvatSucc: false,
            isAccReActvatFail: true,
            contactByReactvtSucc: loginId,
            errorCode: error.response.data.code,
          });
          dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/emma/signup/cwp/reactivation-result`));
        } else {
          dispatch({
            type: EM_REG_ACC_REACTIVATE_FAIL,
            isAccReActvatSucc: false,
            isAccReActvatFail: true,
            contactByReactvtSucc: loginId,
            errorCode: 'NWK',
          });
          dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/emma/signup/cwp/fail`));
        }
      });
  };
};
